import { render, staticRenderFns } from "./MyNav.vue?vue&type=template&id=fb264152&scoped=true&"
import script from "./MyNav.vue?vue&type=script&lang=js&"
export * from "./MyNav.vue?vue&type=script&lang=js&"
import style0 from "./MyNav.vue?vue&type=style&index=0&id=fb264152&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb264152",
  null
  
)

export default component.exports